import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { finalize, map, switchMap, tap } from 'rxjs/operators';
import { daysOfMonth } from 'src/app/common/utils/date.utils';
import { HolidayService } from 'src/app/data/holiday.service';
import { Filter } from 'src/app/models/common/filter';
import { HolidayPerMonthDto } from 'src/app/models/dtos/holiday-per-month-dto';

interface PagingRequest {
    Year: number;
    Month: number;
    Page: number;
    PageSize: number;
    SortingDirection: string;
    SortingField: string;
    Filters: Filter[]
}

export interface HolidayPerMonthViewModel extends HolidayPerMonthDto { }

@Injectable({
    providedIn: 'root',
})
export class HolidayPerMonthListDataSource {
    private holidayService = inject(HolidayService);

    countSubject = new BehaviorSubject<number>(0);
    count$: Observable<number> = this.countSubject.asObservable();
    isLoadingSubject = new BehaviorSubject<boolean>(false);
    isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();
    pageOptionsSubject = new Subject<PagingRequest>();
    private holidaysSubject = new BehaviorSubject<HolidayPerMonthViewModel[]>(null);

    holidays$: Observable<HolidayPerMonthViewModel[]> = this.holidaysSubject.asObservable();

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        var a = this.pageOptionsSubject.pipe(
            tap(() => this.isLoadingSubject.next(true)),
            switchMap((request) => this.holidayService.getHolidaysPerMonth(request.Year, request.Month, request.Page, request.PageSize, request.SortingField, request.SortingDirection, request.Filters)
                .pipe(map((res) => ({
                    ...res,
                    Results: res?.Results?.map(r => ({
                        ...r,
                        AbsenceDays: daysOfMonth(new Date(request.Year, request.Month - 1, 1)).map(d => r.AbsenceDays.find(ad => ad.Date.setHours(0, 0, 0, 0) === d.setHours(0, 0, 0, 0)) ?? { Date: d })
                    } as HolidayPerMonthViewModel))
                })))
                .pipe(finalize(() => this.isLoadingSubject.next(false)))
            ),
            tap((res) => this.countSubject.next(res.Count)),
            map((res) => res.Results as HolidayPerMonthViewModel[])
        );
        a.subscribe(this.holidaysSubject as any);
    }
}
